<template>
  <div class="collapsible-tree" :class="{ collapsed: !visible }">
    <div class="tree-collapse-btn" @click="$emit('toggle')">
      <i :class="visible ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
    </div>
    <!-- ponytail: 默认使用 OrganizationTree，通过 tree-content slot 可替换为自定义树内容 -->
    <div v-show="visible" class="tree-inner">
      <slot name="tree-actions"></slot>
      <slot name="tree-content">
        <OrganizationTree @node-click="(n) => $emit('node-click', n)" />
      </slot>
    </div>
  </div>
</template>

<script>
import OrganizationTree from "./OrganizationTree.vue";
export default {
  name: "CollapsibleTree",
  components: { OrganizationTree },
  props: {
    visible: { type: Boolean, default: true },
  },
  emits: ["toggle", "node-click"],
};
</script>

<style lang="less" scoped>
.collapsible-tree {
  width: 280px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 8px 8px 0;
  transition: width 0.25s ease;

  &.collapsed {
    width: 36px;
    padding: 8px 7px;
    min-width: 36px;
    overflow: hidden;
    align-items: center;
  }

  .tree-collapse-btn {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #909399;
    background: #f0f2f5;
    transition: all 0.2s;
    margin-left: auto;
    &:hover { background: #e0e4ea; color: #2A62FF; }
  }

  .tree-inner {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}
</style>
